/* eslint-disable import/order */
/* eslint-disable import/first */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */

const jQuery = require('jquery');

window.$ = jQuery;
window.jQuery = jQuery;

const LimeLight = require('@dotdev/limelight').default;

const ShopifyCart = require('shopify-cart').default;

// needs to be require to require(entire module for webpack
const themeSections = require('@shopify/theme-sections');

require('../modules/breakpoints.cjs');

const themeCart = require('../modules/cart.cjs').default;

const imageLazyload = require('../modules/image-lazyload.cjs').default;

const rteWrappers = require('../modules/rte-wrappers.cjs').default;

const limelightAccordions = require('../modules/limelight-accordions.cjs').default;

const limelightSelects = require('../modules/limelight-selects.cjs').default;

const stickyHeader = require('../modules/sticky-header.cjs').default;

const Cards = require('../modules/cards.cjs').default;

const scrollState = require('../modules/scroll-state.cjs').default;

const easeIn = require('../modules/ease-in.cjs').default;

const Currency = require('../modules/currency.cjs').default;

const Ajaxinate = require('../modules/ajaxinate.cjs').default;

window.theme = window.theme || {};
window.Ajaxinate = Ajaxinate;
window.Limelight = LimeLight;
window.Cart = ShopifyCart;

require('../sections/theme-announcements.cjs').default();

require('../sections/theme-header.cjs').default();

require('../sections/theme-footer.cjs').default();

/* fixed Geolocation, but probably would not use it for now anyway
require('../sections/country-switcher.cjs').default();
*/

require('../sections/theme-popups.cjs').default();
/*
require('../sections/theme-skincare-quiz';
*/

// Global vars

// Make NodeList.forEach() method work on internet explorer
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// Load sections
themeSections.load(['theme-announcements', 'theme-header', 'theme-footer', 'theme-popups', 'country-switcher' /*, 'theme-skincare-quiz'*/ ]);

// Init on doc ready
document.addEventListener('DOMContentLoaded', () => {
  imageLazyload();
  rteWrappers();
  limelightAccordions();
  limelightSelects();
  stickyHeader();
  Cards();
  scrollState();
  easeIn();
  Currency();
  themeCart();
});
